import {useEffect, useState} from "react";
import {Autocomplete, Chip, TextField, Tooltip} from "@mui/material";

export default function AutocompleteChipsView(props) {
  const [valueObjList, setObjList] = useState(props.objList);
  const [list, setList] = useState(valueObjList.getList());

  useEffect(() => {
    // When props.objList changes, update the state
    setObjList(props.objList);
    setList(props.objList.getList());
  }, [props.objList]);

  function addValue(value) {
    if (!value) {
      return;
    }
    valueObjList.addLanguageValue(props.lang, value);
    setObjList(valueObjList);
    setList([...valueObjList.getList()]);
    props.onChange(valueObjList); // Notify parent component
  }

  function removeValue(index) {
    valueObjList.removeItemOfLang(index, props.lang);
    setObjList(valueObjList);
    setList([...valueObjList.getList()]);
    props.onChange(valueObjList); // Notify parent component
  }

  function containsValue(value, list2Check) {
    for (let index = 0; index < list2Check.length; index++) {
      const item = list2Check[index];
      for (const [k, v] of item.map) {
        if (v === value && k === props.lang) {
          return true;
        }
      }
    }
    return false;
  }

  function onTagsChange(event, values) {
    for (let index = 0; index < values.length; index++) {
      const value = values[index];
      if (!containsValue(value, list)) {
        addValue(value);
      }
    }
  }

  function onChipDelete(index) {
    removeValue(index);
  }

  const id = "lds-aut-clr";

  function onbl(e) {
    const value = e.target.value;
    if (value) {
      onTagsChange(null, [value]);
      clearInputValue();
    }
  }

  function clearInputValue() {
    const clrInt = setInterval(() => {
      // const el = document.getElementById(id);
      const el = document.querySelector("input#" + id + "." + "MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputAdornedStart.MuiInputBase-inputAdornedEnd.MuiAutocomplete-input.MuiAutocomplete-inputFocused.css-152mnda-MuiInputBase-input-MuiOutlinedInput-input");
      if (el) {
        el.value = "";
        el.defaultValue = "";
        // el.remove();
        clearInterval(clrInt);
      }
    }, 10);
  }

  // Map the list to get the values for the selected language
  const selectedValues = list
    .filter((item) => item.containsLang(props.lang)) // Filter by the language prop
    .map((item) => item.getValue(props.lang)); // Get the values for that language

  return (
    <Autocomplete
      clearIcon={false}
      value={selectedValues}
      options={[]}
      freeSolo
      multiple
      onChange={onTagsChange}
      renderTags={(value, props) =>
        value.map((option, index) => (
          <Chip
            key={index}
            label={option}
            {...props({index})}
            onDelete={() => {
              onChipDelete(index);
            }}
          />
        ))
      }
      renderInput={(params) => {
        return (
          <Tooltip followCursor placement="top-start" title={"Press enter after entering the desired value"}>
            <TextField
              id={id}
              label={"Add " + props.label}
              required={props.required}
              helperText={props.helperText}
              placeholder={props.placeholder}
              {...params}
              onBlur={(e) => {
                onbl(e);
              }}
            />
          </Tooltip>
        );
      }}
    />
  );
}
